import BirthdayFields from '~/javascripts/components/LeadForm/BirthdayFields';
import InternationalPhoneNumberInput from '~/javascripts/components/InternationalPhoneNumberInput';
import RateLimitedRecaptchaForm from '~/javascripts/behaviors/RateLimitedRecaptchaForm';
import RecaptchaBadge from '~/javascripts/components/RecaptchaBadge';
import RecaptchaText from '~/javascripts/components/RecaptchaText';
import StoreUtmParams from '~/javascripts/behaviors/StoreUtmParams';
import { observer, useLocalObservable } from 'mobx-react';
import { useEffect, useRef } from 'react';

const LeadForm = observer((props) => {
  const leadFormRef = useRef(null);

  const formattedOfferFromProps = () => {
    if (typeof props.offer === 'string') {
      return props.offer;
    } else if (typeof props.offer === 'object') {
      return props.offer?.value?.data?.name;
    }
  };

  const localStore = useLocalObservable(() => ({
    showPhoneConsentCheckbox: false,
    customWelcomeJourneyId: props.customWelcomeJourneyId || '',
    offer: formattedOfferFromProps(),
  }));

  useEffect(() => {
    if (leadFormRef.current) {
      RateLimitedRecaptchaForm($(leadFormRef.current));
      StoreUtmParams($(leadFormRef.current));

      $(leadFormRef.current).on('ajax:complete', (_xhr, response) => {
        if (response.status == 200 && props.useInlineThankYouBlock) {
          replaceLeadFormWithThankYouContent();
        }
      });
    }
  }, []);

  const replaceLeadFormWithThankYouContent = () => {
    if ($('.infosite-lead-form-thank-you-content').length > 0) {
      $('.infosite-lead-form-sign-up-content').addClass('hidden');
      $('.infosite-lead-form-thank-you-content').removeClass('hidden');
    } else {
      $('.lead-form-sign-up-content').addClass('hidden');
      $(leadFormRef.current.parentElement).html(
        props.inlineThankYouBlockContent
      );
    }
  };

  const mailingListInputs = () => {
    const mailingListsToJoin = Array.isArray(props.mailingListsToJoin)
      ? props.mailingListsToJoin
      : Object.entries(props.mailingListsToJoin)
          .filter(([_k, v]) => v === true)
          .map(([k, _v]) => k);

    return mailingListsToJoin.map((mailingList) => (
      <input
        id={`user_${mailingList}`}
        key={mailingList}
        name={`mailing_list_subscriber[${mailingList}]`}
        type='hidden'
        value
      />
    ));
  };

  const handleBirthdayCheckboxChange = (checked) => {
    if (checked) {
      localStore.offer = props.birthdayPledgeCheckbox.offer?.value?.data?.name;
      localStore.customWelcomeJourneyId =
        props.birthdayPledgeCheckbox.customWelcomeJourneyId;
    } else {
      localStore.offer = formattedOfferFromProps();
      localStore.customWelcomeJourneyId = props.customWelcomeJourneyId || '';
    }
  };

  return (
    <>
      <div className='lead-form-wrapper theme-maji'>
        <form
          action='/mailing_list_subscribers'
          className={`w-full text-center ${
            props.place == 'footer' ? '' : 'mt-3'
          }`}
          data-parsley-validate
          data-remote
          data-store-utm-params-model='mailing_list_subscriber'
          data-with-credentials
          id='mailing-list-form'
          method='POST'
          ref={leadFormRef}
        >
          <div
            className={`name-email-wrapper ${
              props.place == 'footer' ? 'md-flex' : ''
            }`}
          >
            <div className='mailing-input-names md-flex md-justify-center max-w-xs mx-auto'>
              <div className='mailing-input-wrapper name first md-flex-1'>
                <label className='for-screen-readers-only' htmlFor='name'>
                  First Name
                </label>
                <input
                  className='border-b-0 md-border-b md-border-r-0 rounded-none rounded-t md-rounded-none md-rounded-l'
                  data-parsley-error-message='Please provide your first name'
                  id='user_name'
                  maxLength='255'
                  name='user[name]'
                  placeholder='First name'
                  required
                  type='text'
                />
              </div>
              <div className='mailing-input-wrapper surname mt-0 md-mt-0 md-flex-1'>
                <label className='for-screen-readers-only' htmlFor='surname'>
                  Last Name
                </label>
                <input
                  className={`rounded-none ${
                    props.place == 'footer'
                      ? ''
                      : 'rounded-b md-rounded-none md-rounded-r'
                  }`}
                  data-parsley-error-message='Please provide your last name'
                  id='user_surname'
                  maxLength='255'
                  name='user[surname]'
                  placeholder='Last name'
                  required
                  type='text'
                />
              </div>
            </div>
            <div
              className={`mailing-input-wrapper email max-w-xs mx-auto ${
                props.place == 'footer' ? '' : 'mt-1'
              } ${props.showBirthday ? '' : 'second'}`}
            >
              <label className='for-screen-readers-only' htmlFor='email'>
                Email
              </label>
              <input
                data-parsley-email-tld=''
                data-parsley-error-message='Please provide a valid email address'
                id='user_email'
                maxLength='255'
                name='user[email]'
                placeholder='Email'
                required
                type='email'
              />
            </div>

            {props.place == 'footer' && (
              <button
                className='button button--expand mailing-list-sign-up-button max-w-xs mx-auto'
                type='submit'
              >
                {props.submitButtonText || 'Subscribe'}
              </button>
            )}
          </div>

          {props.showBirthday && (
            <BirthdayFields
              birthdayPledgeCheckbox={props.birthdayPledgeCheckbox}
              countryFromLocale={props.countryFromLocale}
              handleBirthdayCheckboxChange={handleBirthdayCheckboxChange}
              place={props.place}
              requireBirthday={props.requireBirthday}
            />
          )}

          {props.showPhoneNumber && props.countryFromLocale === 'us' && (
            <div className='phone-number-fields max-w-xs mx-auto mt-1'>
              <InternationalPhoneNumberInput
                customInputClassName={
                  localStore.showPhoneConsentCheckbox ? 'rounded-b-none' : ''
                }
                defaultCountry='us'
                inputName='user[phone_num]'
                isRequired={props.requirePhoneNumber}
                limitToUSOnly={true}
                onChange={(newNumber) => {
                  localStore.showPhoneConsentCheckbox = !!newNumber;
                }}
              />

              {localStore.showPhoneConsentCheckbox && (
                <div
                  className='border border-solid border-grey-40 border-t-0 py-2 px-1 rounded-b bg-grey-10'
                  style={{
                    marginTop: -16,
                  }}
                >
                  <div
                    className='flex'
                    style={{
                      gap: 14,
                    }}
                  >
                    <input
                      className='cursor-pointer'
                      data-parsley-error-message='Please agree to receive text messages, if providing your phone number'
                      data-parsley-errors-container='.phone-number-errors-container'
                      defaultChecked={false}
                      name='_consent_to_sms'
                      required
                      style={{
                        height: 18,
                        width: 18,
                      }}
                      type='checkbox'
                    />
                    <div style={{ width: 306 }}>
                      <span>
                        By checking this box, you agree to receive recurring
                        automated promotional & personalized marketing text
                        messages from charity: water at this number. Consent is
                        not a condition of purchases. Reply HELP for help and
                        STOP to cancel.
                        <br />
                      </span>
                      <span className='text-grey-60 italic text-small'>
                        Msg frequency varies. Msg & data rates may apply. View{' '}
                        <a
                          className='text-grey-50'
                          href='/sms-terms-of-service'
                        >
                          Terms
                        </a>{' '}
                        &{' '}
                        <a className='text-grey-50' href='/privacy-policy/sms'>
                          Privacy Policy
                        </a>
                        .
                      </span>
                    </div>
                  </div>
                </div>
              )}

              <div className='phone-number-errors-container' />
            </div>
          )}

          {props.place != 'footer' && (
            <button
              className='button cw-button button--expand mailing-list-sign-up-button max-w-xs mx-auto mt-1'
              type='submit'
            >
              {props.submitButtonText || 'Subscribe'}
            </button>
          )}

          <input
            id='user_country'
            name='user[country]'
            type='hidden'
            value={props.countryFromLocale}
          />
          {mailingListInputs()}
          <input
            id='user_place'
            name='user[place]'
            type='hidden'
            value={props.place}
          />
          <input
            id='offer'
            name='offer'
            type='hidden'
            value={localStore.offer}
          />
          <input
            id='user_thank_you_flash_message'
            name='thank_you_flash_message'
            type='hidden'
            value={props.thankYouFlashMessage}
          />
          <input
            id='user_thank_you_page_path'
            name='thank_you_page_path'
            type='hidden'
            value={props.thankYouPagePath}
          />
          <input
            id='user_use_inline_thank_you_block'
            name='use_inline_thank_you_block'
            type='hidden'
            value={props.useInlineThankYouBlock === true ? 'true' : ''}
          />
          <input
            id='user_send_default_welcome_emails'
            name='send_default_welcome_emails'
            type='hidden'
            value={
              props.sendDefaultWelcomeEmails === undefined
                ? 'true'
                : `${props.sendDefaultWelcomeEmails}`
            }
          />
          <input
            id='user_custom_welcome_journey_id'
            name='custom_welcome_journey_id'
            type='hidden'
            value={localStore.customWelcomeJourneyId}
          />
          <input
            id='user_offer_journey_id'
            name='offer_journey_id'
            type='hidden'
            value={props.offerJourneyId}
          />
          <RecaptchaBadge />
        </form>

        <div
          className={`w-full ${props.place == 'footer' ? '' : 'text-center'}`}
        >
          {props.countryFromLocale === 'uk' && (
            <p
              className={`h80 italic normal-case text-grey-60 pt-1 balance-text ${
                props.place == 'footer' ? '' : 'max-w-xs mx-auto'
              }`}
            >
              By clicking &apos;{props.submitButtonText}&apos; I accept the
              terms and conditions of the privacy policy and consent to receive
              email updates and stories from charity:&nbsp;water.
            </p>
          )}
          <RecaptchaText classes='text-grey-50 mt-1' />
        </div>
      </div>
    </>
  );
});

export default LeadForm;
